














import { Vue, Component, Prop } from 'vue-property-decorator';
import EventBus from '@/utils/EventBus';
import { Getter } from 'vuex-class';

@Component({
  name: 'app-button-back',
  components: {
    BackIcon: () => import('@/components/icon/BackIcon.vue'),
  },
})
export default class extends Vue {
  @Prop({type: String, required: true})
  private readonly routeName!: string;

  @Getter('dataManagement/themeColor')
  private readonly themeColor!: CSSStyleDeclaration['color'];

  public mounted(): void {
    this.$el.addEventListener('keydown', (e: Event) => {
      if ((e as KeyboardEvent).key === 'Enter') {
        this.emitButtonClicked();
      }
    });
  }

  private async emitButtonClicked(): Promise<void> {
    this.$store.commit('dataManagement/SET_IFRAME_URL_QUERY', '');
    this.$store.commit('dataManagement/CLEAR_NAVIGATED_LISTS');
    EventBus.$emit('nav:go-previous-data-list');
  }
}
